import React, { useEffect, useState } from "react";
import "./Detail.css";
import { connect } from "react-redux";
import favPurpleOutline from "../../img/parts/bookmark-purple-outline.png";
import favPurpleFilled from "../../img/parts/bookmark-purple-filled.png";
import ShortcutOutlinedIcon from "@mui/icons-material/ShortcutOutlined";
import SharePopUp from "./SharePopUp";
import { selectUser } from "../../features/auth/authSlice";
import {
  selectAllWishlists,
  addToWishlistsAsync,
  removeFromWishlistAsync,
  fetchAllWishlistsAsync,
} from "../../features/wishlist/wishlistSlice";
import {
  toggleOverlay,
  selectIsOverlayVisible,
} from "../../store/slices/headerSlice";
import { useDispatch, useSelector } from "react-redux";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

function FavShare({ selectedProduct, isOverlayVisible, toggleOverlay }) {
  const [showSharePopup, setShowSharePopup] = useState(false);
  const userDetail = useSelector(selectUser); // Get user detail
  const wishlist = useSelector(selectAllWishlists); // Get all wishlist products
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };

  useEffect(() => {
    dispatch(fetchAllWishlistsAsync(userDetail.UserID));
  }, [dispatch, userDetail.UserID, selectedProduct]);

  const toggleSharePopup = () => {
    setShowSharePopup(!showSharePopup);
  };

  const closeSharePopup = () => {
    setShowSharePopup(false);
  };

  const handleLoginOverlay = () => {
    toggleOverlay();
  };

  // TO ADD PRODUCT INTO WISHLIST
  const handleAddToWishlist = (selectedProduct, event) => {
    handleOpen();
    let wishlistData = {
      UserID: userDetail?.UserID,
      prodID: selectedProduct.prod_ID,
    };
    dispatch(addToWishlistsAsync(wishlistData)).then(() =>
      dispatch(fetchAllWishlistsAsync(userDetail.UserID)).then(() => {
        handleClose();
      })
    ); // Fetch updated wishlist
    event.preventDefault();
  };

  const handleRemoveFromWishlist = async (data, e) => {
    handleOpen();
    let wishlistData = {
      UserID: userDetail?.UserID,
      prodID: data?.prod_ID,
    };
    dispatch(removeFromWishlistAsync(wishlistData)).then(() => {
      dispatch(fetchAllWishlistsAsync(userDetail.UserID)).then(() => {
        handleClose();
      });
    });
    e.preventDefault();
  };

  // Function to check if a product is in the wishlist
  const isInWishlist = (productId) => {
    return (
      Array.isArray(wishlist && wishlist?.product) &&
      wishlist?.product?.some((item) => item.prod_ID === productId)
    );
  };

  return (
    <div className="product-fav-share">
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open} // Show backdrop when either open or filtering state is true
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <div className="favourite">
        {isInWishlist(selectedProduct?.prod_ID) ? (
          <>
            <img
              loading="lazy"
              src={favPurpleFilled}
              alt=""
              style={{
                // width: "1.5vw",
                marginRight: "9px",
                cursor: "pointer",
              }}
              onClick={(event) => {
                handleRemoveFromWishlist(selectedProduct, event);
              }}
            />
            <span>Added</span>
          </>
        ) : (
          <>
            <img
              loading="lazy"
              src={favPurpleOutline}
              alt=""
              style={{
                // width: "1.5vw",
                marginRight: "9px",
                cursor: "pointer",
                display: selectedProduct?.Manufacturer === "ESI" && "none",
              }}
              onClick={(event) => {
                userDetail && userDetail?.UserID
                  ? handleAddToWishlist(selectedProduct, event)
                  : handleLoginOverlay();
              }}
            />
            <span
              style={{
                display: selectedProduct?.Manufacturer === "ESI" && "none",
              }}
            >
              Add to List
            </span>
          </>
        )}
      </div>
      <span
        className="share"
        style={{ cursor: "pointer" }}
        onClick={toggleSharePopup}
      >
        <ShortcutOutlinedIcon
          style={{
            color: "#800080",
            // fontSize: "1.5rem",
            marginRight: "9px",
          }}
        />
        <span>Share</span>
      </span>
      {showSharePopup && <SharePopUp onClose={closeSharePopup} />}
     
    </div>
  );
}

const mapStateToProps = (state) => ({
  isOverlayVisible: selectIsOverlayVisible(state),
});
const mapDispatchToProps = {
  toggleOverlay,
};
export default connect(mapStateToProps, mapDispatchToProps)(FavShare);
